import { takeLatest, put, call, all } from 'redux-saga/effects';
import ChannelApi from './channel-api';
import ChannelActions from './channel-actions';

function* fetchChannelsHandler({ payload }) {
  try {
    const channels = yield call(ChannelApi.fetchChannels);
    yield put(ChannelActions.fetchSuccess(channels));
  } catch (error) {
    yield put(ChannelActions.fetchFailure(error));
  }
}

export default function* channelSagas() {
  yield all([takeLatest(ChannelActions.fetch.getType(), fetchChannelsHandler)]);
}
